<template>
  <div class="card bg-light mb-3 border-0 p-10">
    <div class="card-body">
      <div class="card-title">
        <div style="margin-left: 40px">
          <div class="row">
            <span>
              {{
                data.participantType === 1
                  ? $t('Sığortalı') + ' ' + data.regNumber
                  : $t(data.participantTypeName) + ' : ' + data.regNumber
              }}
            </span>
            <dir class="col-12">
              <upload :showUpload="true" :disabled="readonly" :sourcetype="2" :sourceId="data.id" :downloadAll="true">
              </upload>
            </dir>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Upload from "./Upload.vue";
export default {
  components: {
    Upload,
  },
  props: {
    item: Object,
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      data: this.item,
    };
  },
  methods: {
    handleCommand(command) {
      let id = command.id;
      if (command.action === "edit") this.handleEdit(id);
      else if (command.action === "delete") this.handleDelete(id);
    },
    handleEdit(id) {
      this.$emit("edit", id);
    },
    handleDelete(id) {
      this.$emit("delete", id);
    },
  },
  watch: {
    item() {
      this.data = this.item;

    },
  },
};
</script>

<style lang="scss" scoped>

</style>